<template>
  <v-app-bar color="primary" dark app>
    <!-- TODO: Permitir mostrar/ocultar el panel lateral... -->
    <v-spacer></v-spacer>

    <!-- Notificaciones (CO-18: el Administrador de Grupo no recibe notificaciones) -->
    <app-notifications v-if="!isGroupAdmin"/>

    <!-- Botón de descarga del manual de usuario -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
          @click="downloadManual"
          class="mx-1"
        >
          <v-icon left>mdi-file-pdf-box</v-icon>
          Manual
        </v-btn>
      </template>
      <span>Descargar Manual de Usuario</span>
    </v-tooltip>

    <!-- Opciones de usuario -->
    <v-menu
      v-model="showMenu"
      v-if="isLoggedIn"
      :close-on-content-click="false"
      :nudge-width="200"
    >
      <template v-slot:activator="{ on }">
        <v-avatar v-on="on" size="36" class="v-avatar-mini--profile">
            <img :src="avatar" alt="Avatar"/>
        </v-avatar>
      </template>
      <v-card :img="profileBg" class="v-card--profile white" width="275">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="showMenu = false" icon dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-center">
          <v-avatar size="128" class="v-avatar--profile">
            <img :src="avatar" alt="Avatar"/>
          </v-avatar>
            <p class="text-subtitle-2 mt-2 font-weight-bold">
            Hola {{ username.name }}!<br>
            <span class="text-caption">{{ username.email }}</span>
          </p>
          <v-btn @click="logout()" class="ma-2" outlined color="blue">Cerrar sesión</v-btn>
        </v-card-text>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import AppNotifications from './AppNotifications'
import UserService from '@/services/UserService'

export default {
  name: 'app-toolbar',
  components: {
    AppNotifications
  },

  data: () => ({
    link: true,
    showMenu: false,
    user_name: ''
  }),

  computed: {
    ...mapGetters({
      user: 'CURRENT_USER',
      isLoggedIn: 'LOGGED_IN',
      isGroupAdmin: 'IS_GROUP_ADMIN'
    }),
    username () {
      return JSON.parse(localStorage.getItem('username'))
    },
    avatar () {
      if (localStorage.getItem('logo')) {
        return JSON.parse(localStorage.getItem('logo')).url
      } else {
        return require('@/assets/avatar.gif')
      }
    },
    profileBg () {
      // const theme = localStorage.getItem('theme')
      /* if (theme === 'green') {
        return require('@/assets/profile-bg3.jpg')
      }
      if (theme === 'red') {
        return require('@/assets/profile-bg-red.jpg')
      }
      if (theme === 'dark') {
        return require('@/assets/profile-bg-black.jpg')
      } */
      return require('@/assets/profile-bg.jpg')
    }
  },

  methods: {
    logout () {
      this.$store.dispatch('LOGOUT').then(() => {
        this.$router.push({ name: 'Login' })
      })
    },

    async downloadManual () {
      try {
        const response = await UserService.downloadManual()
        
        // Crear URL para el blob
        const url = window.URL.createObjectURL(response.data)
        
        // Crear elemento de enlace temporal
        const link = document.createElement('a')
        link.href = url
        link.download = 'MANUAL_USUARIO_PIVOTFLEET.pdf'
        link.style.display = 'none'
        
        // Agregar al DOM, hacer click y limpiar
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // Limpiar URL
        window.URL.revokeObjectURL(url)
        
        this.$toast.success('Manual descargado correctamente')
      } catch (error) {
        console.error('Error al descargar el manual:', error)
        this.$toast.error('Error al descargar el manual de usuario')
      }
    }
  }
}
</script>

<style>
  .v-card--profile {
    background-size: 100% auto !important;
    background-position: top center !important;
  }
  .v-avatar-mini--profile {
    cursor: pointer;
  }
  .v-avatar--profile {
    box-shadow: 1px 1px 3px rgba(0, 0, 0, .35);
  }
</style>
